<mat-spinner *ngIf="themeService.spinner" color="warn" class="centerOfAll" [diameter]="50"
  fxLayoutAlign="center center"></mat-spinner>
<!-- back button  -->
<button mat-button fxLayoutAlign="start start" (click)="navigateBack()" color="primary">
  <mat-icon color="primary">arrow_back</mat-icon>
  <span style="margin-top: 10px; margin-left: 4px">Back to previous</span>
</button>
<div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="15px">
  <div dir="textDirection" fxLayout="column" fxLayoutAlign="center center">
    <br />
    <h2><b>General Settings</b></h2>
  </div>
  <div fxLayout="column" [ngStyle]="{ width: '65%' }" [ngStyle.lt-sm]="{ width: '85%' }">
    <mat-accordion>
      <!-- <mat-expansion-panel>
       <mat-expansion-panel-header>
          <mat-panel-title> Workspace </mat-panel-title>
          <mat-panel-description>
            TODO
          </mat-panel-description>
        </mat-expansion-panel-header>
        <p>
          TODO
        </p>
      </mat-expansion-panel>-->
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title> Locale </mat-panel-title>
        </mat-expansion-panel-header>
        <div fxLayout="column" fxLayoutGap="3%" style="width: 100%;">
          <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5%" style="width: 100%;">
            <div style="width: 5%;"></div>
            <span style="width: 10%;">Currency</span>
            <mat-form-field style="width: 80%;">
              <input type="text" #input placeholder="Choose Currency" aria-label="Number" matInput
                [formControl]="currencyControl" [(ngModel)]="selectedCurrency" (focus)="currencySelected(input.value)"
                [matAutocomplete]="auto">
                <button matSuffix mat-icon-button aria-label="Clear" (click)="selectedCurrency=''"><mat-icon>close</mat-icon></button>
              <mat-autocomplete #auto="matAutocomplete">
                <mat-option *ngFor="let value of filteredCurrencyOptions |async; trackBy: trackByFn" [value]="value.name">
                  {{ getCurrencySymbol(value.code) }} {{ value.name }} - {{value.code}}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
            <div style="width: 5%;"></div>
          </div>
          <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="5%" style="width: 100%;">
            <div style="width: 5%;"></div>
            <span style="width: 10%;">Timezone</span>
            <mat-form-field style="width: 80%;">
              <input type="text" #input placeholder="Pick your timezone" aria-label="Number" matInput
                [formControl]="timeZoneControl" [(ngModel)]="selectedTimeZone" (focus)="timezoneSelected(input.value)"
                [matAutocomplete]="autoTimeZone">
                <button matSuffix mat-icon-button aria-label="Clear" (click)="selectedTimeZone=''"><mat-icon>close</mat-icon></button>
              <mat-autocomplete #autoTimeZone="matAutocomplete">
                <mat-option *ngFor="let option of filteredTimezoneOptions |async; trackBy: trackByFn" [value]="option">
                  {{option}}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
            <div style="width: 5%;"></div>
          </div>

          <!-- <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="5%" style="width: 100%;">
            <div style="width: 5%;"></div>
            <span style="width: 10%;">Date Format</span>
            <mat-form-field style="width: 80%;">
              <mat-select [(ngModel)]="selectedDateFormat" placeholder="Select a date format">
                <mat-option *ngFor="let value of dateFormat; trackBy: trackByFn" [value]="value.value" (click)="dateformatSelected(value)">
                  {{ value.name }}
                </mat-option>
              </mat-select>
              <mat-hint *ngIf="displayDate" style="color: #1B51B5; font-size: larger;">Preview Date : {{ displayDate }}</mat-hint>
            </mat-form-field>
            <div style="width: 5%;"></div>
          </div>
          <div *ngIf="!displayDate" fxLayoutAlign="center center" fxLayoutGap="5%" style="width: 100%;">
            <div style="width: 10%;"></div>
            <span style="width: 10%;" fxLayoutAlign="start center"></span>
            <mat-form-field style="width: 75%;">
              <input type="text" #customdateinput placeholder="Enter a custom date format" aria-label="Number" matInput [(ngModel)]="selectedCustomDateFormat"
              (input)="customDateformatSelected($event)">
              <mat-hint style="color: #1B51B5; font-size: larger;">Preview Date : {{ customDisplayDate }}</mat-hint>
              <button matSuffix mat-icon-button aria-label="Clear" (click)="clearCustomDate()"><mat-icon>close</mat-icon></button>
            </mat-form-field>
            <div style="width: 5%;"></div>
          </div>

          <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="5%" style="width: 100%;">
            <div style="width: 5%;"></div>
            <span style="width: 10%;">Time Format</span>
            <mat-form-field style="width: 80%;">
              <mat-select [(ngModel)]="selectedTimeFormat" placeholder="Select a time format">
                <mat-option *ngFor="let value of timeFormat; trackBy: trackByFn" [value]="value.value" (click)="timeformatSelected(value)">
                  {{ value.name }}
                </mat-option>
              </mat-select>
              <mat-hint *ngIf="displayTime" style="color: #1B51B5; font-size: larger;">Preview Time : {{ displayTime }}</mat-hint>
            </mat-form-field>
            <div style="width: 5%;"></div>
          </div>
          <div *ngIf="!displayTime" fxLayoutAlign="center center" fxLayoutGap="5%" style="width: 100%;">
            <div style="width: 10%;"></div>
            <span style="width: 10%;" fxLayoutAlign="start center"></span>
            <mat-form-field style="width: 75%;">
              <input type="text" #customtimeinput placeholder="Enter a custom time format" aria-label="Number" matInput [(ngModel)]="selectedCustomTimeFormat"
              (input)="customTimeformatSelected($event)">
              <mat-hint style="color: #1B51B5; font-size: larger;">Preview Time : {{ customDisplayTime }}</mat-hint>
              <button matSuffix mat-icon-button aria-label="Clear" (click)="clearCustomTime()"><mat-icon>close</mat-icon></button>
            </mat-form-field>
            <div style="width: 5%;"></div>
          </div> -->

          <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5%" style="width: 100%;">
            <div style="width: 5%;"></div>
            <span style="width: 10%;">Date & Time Format</span>
            <date-time-format-config
              style="width: 80%;"
              [dateTimeFormatConfig]="{
                dateFormat: selectedDateFormat,
                timeFormat: selectedTimeFormat
              }"
              (dateTimeFormatChanged)="dateTimeFormatChanged($event)"
            ></date-time-format-config>
            <div style="width: 5%;"></div>
          </div>

          <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="5%" style="width: 100%;">
            <div style="width: 5%;"></div>
            <span style="width: 10%;">Decimal Format</span>
            <mat-form-field style="width: 80%;">
              <mat-select [(ngModel)]="seletedDecimalFormat">
                <mat-option *ngFor="let value of decimalFormat; trackBy: trackByFn" [value]="value.name">
                  ( {{ value.name }} ) - {{value.description}}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <div style="width: 5%;"></div>
          </div>

          <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="5%" style="width: 100%;">
            <div style="width: 5%;"></div>
            <span style="width: 10%;">Digit Grouping</span>
            <mat-form-field style="width: 80%;">
              <mat-select [(ngModel)]="seletedDigitFormat">
                <mat-option *ngFor="let value of digitFormat; trackBy: trackByFn" [value]="value.value">
                  {{ value.value }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <div style="width: 5%;"></div>
          </div>
        </div>
      </mat-expansion-panel>

      <!-- Theme Settings  -->
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title> Theme settings </mat-panel-title>
        </mat-expansion-panel-header>
        <div fxLayout="column" fxLayoutGap="2%">
          <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="5%">
            <span>Change the Theme</span>
            <app-menu [options]="options" [theme]="selectedTheme" (themeChange)="themeChangeHandler($event)">
            </app-menu>
            <button mat-icon-button (click)="resetTheme()">
              <mat-icon>restart_alt</mat-icon>
            </button>
          </div>

          <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="8%">
            <span>Apply dark mode</span>
            <mat-slide-toggle [checked]="isDarkTheme" (change)="toggleDarkTheme($event.checked)">
            </mat-slide-toggle>
          </div>

          <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="5%" style="margin-left: 10px">
            <span>Direction</span>
            <mat-radio-group fxLayout="column" fxLayoutGap="10%" [(ngModel)]="direction"
              (change)="onDirectionChange(direction)">
              <mat-radio-button value="ltr">Left to Right</mat-radio-button>
              <mat-radio-button value="rtl">Right to Left</mat-radio-button>
            </mat-radio-group>
          </div>
          <div fxLayout="row" style="height: 2.5ch"></div>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </div>

  <div fxLayout="row" fxLayoutAlign="end center" fxFlex="50%">
    <button mat-raised-button color="primary" (click)="onSaveClicked()" [disabled]='isSaveDisabled'>
      Save
    </button>
  </div>
</div>
